// extracted by mini-css-extract-plugin
export default {"Error":"Error_Error__da9Pg","Error__Message":"Error_Error__Message__VgvqT"};